import { useGoogleTagManager, useMixpanel, useSentry } from '@/vendors/integrations'

export function useTrackingSession () {
  const gtm = useGoogleTagManager()
  const mixpanel = useMixpanel()
  const { withErrorHandler } = useSentry()

  const trackSessionStarted = ({ user }) => withErrorHandler(() => mixpanel.identify(user.id))

  const trackUserRegistered = ({ method }) => {
    withErrorHandler(() => {
      mixpanel.track('New user', {
        'Method': method
      })

      gtm.track({
        event: 'register',
        auth_method: method
      })
    })
  }

  const trackUserLoggedIn = ({ method }) => {
    withErrorHandler(() => {
      mixpanel.track('Login', {
        'Method': method
      })

      gtm.track({
        event: 'login',
        auth_method: method
      })
    })
  }

  const trackUserLoggedOut = () => withErrorHandler(() => mixpanel.reset())

  return {
    trackSessionStarted,
    trackUserRegistered,
    trackUserLoggedIn,
    trackUserLoggedOut
  }
}